import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as EndorsementCheckmark } from "../../../../../../assets/images/endorsement_checkmark.svg";
import { Button } from '../../../../../common';


const NotLoggedIn = ({ onClose, company, trevexId }) => {

    const navigate = useNavigate();

    const handleLoginClick = () => {
        localStorage.setItem("lastVisited", `/search/${trevexId ? company?.companyID : company?.company?.win}`)
        navigate('/login');
    };

    const handleRegisterClick = () => {
        localStorage.setItem("lastVisited", `/search/${trevexId ? company?.companyID : company?.company?.win}`)
        navigate('/sign-up');
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-40 flex items-center justify-center">
            <div className="p-5 border w-[34rem] shadow-lg rounded-md bg-white text-center">
                <div className="flex justify-between items-center mb-6">
                    <h5 className="text-xl font-semibold text-gray-800">Login To Endorse!</h5>
                    <button onClick={onClose} className="text-2xl font-bold text-gray-600 hover:text-gray-800">&times;</button>
                </div>
                <EndorsementCheckmark className="mx-auto mb-4" />
                <p className="font-medium text-gray-600 mb-6 text-justify" style={{ "fontSize": "14px" }}>
                    Endorsing a business for its payment timeliness not only applauds their financial responsibility but also
                    signals to other businesses the reliability of engaging with them. Your endorsement can boost a business's
                    reputation, fostering a network of trust and timely transactions in the business community.
                    <br /><br />
                    To contribute to this positive ecosystem, please
                    <span className="text-primary cursor-pointer" onClick={handleLoginClick}> login</span> or
                    <span className="text-primary cursor-pointer" onClick={handleRegisterClick}> register</span>.
                    Share your positive experiences and help enhance the credibility of businesses that prioritize prompt payments.
                </p>

                <div className='grid grid-cols-2 gap-4'>
                    <Button
                        onClick={handleLoginClick}
                        classes="text-primary bg-transparent rounded border border-primary px-4 py-2 text-f16 font-semibold transition duration-300 ease-in-out w-full">
                        Login
                    </Button>
                    <Button
                        onClick={handleRegisterClick}
                        classes="text-white bg-primary rounded px-4 py-2 text-f16 font-semibold transition duration-300 ease-in-out w-full">
                        Register
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NotLoggedIn;
